var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandDefenseFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0007 92.0475C47.0007 92.0475 7.52073 73.8228 7.52073 17.0901C32.0792 11.6982 39.2965 2.38281 47.0007 2.38281C54.705 2.38281 61.9223 11.6982 86.4807 17.0901C86.4807 71.9428 47.0007 92.0475 47.0007 92.0475Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0012 82.9275C47.0012 82.9275 47.0007 61.8755 47.0007 38.8287C47.0008 23.8198 47.0013 20.1209 47.0012 12.0703C53.0894 12.0703 58.7929 19.4318 78.2001 23.6927C78.2001 67.0398 47.0012 82.9275 47.0012 82.9275Z",
    fill: "url(#paint0_linear_692_13668)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_13668",
    x1: 78.2001,
    y1: 52.1216,
    x2: 48.8639,
    y2: 57.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandDefenseFilled);
export default __webpack_public_path__ + "static/media/brand-defense-filled.4aad1c42439549f72d5135b83cd6c643.svg";
export { ForwardRef as ReactComponent };